module.exports = __webpack_public_path__ + "static/img/product04-5.2dcb1512.png";